/* eslint-disable import/prefer-default-export */
export { default as DemoTemplate } from './DemoTemplate';
